import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ave_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (token && config.method && ["post", "put", "delete"].includes(config.method.toLowerCase())
      && config.url && (config.url.startsWith("/products") || config.url.startsWith("/orders/"))) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
